module.exports = __webpack_public_path__ + "img/4.ec1387b.svg";